import { render, staticRenderFns } from "./WhatsappEdit.vue?vue&type=template&id=082b7474&scoped=true&"
import script from "./WhatsappEdit.vue?vue&type=script&lang=js&"
export * from "./WhatsappEdit.vue?vue&type=script&lang=js&"
import style0 from "./WhatsappEdit.vue?vue&type=style&index=0&id=082b7474&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "082b7474",
  null
  
)

export default component.exports